var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"info","outlined":""},on:{"click":_vm.login}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" "+_vm._s(_vm.icons.mdiMicrosoft)+" ")]),_c('span',[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }